<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <Form :model="windowAddItem" :label-width="200"
                label-position="left">
            <FormItem label='网站标题' prop='site_title'>
              <Input clearable v-model='windowAddItem.site_title' :placeholder="$t('请输入网站标题')"
                     style="width: 300px;"></Input>
              <internationality keyword='site_config|site_title'></internationality>
            </FormItem>

            <FormItem label="网站LOGO" prop="logo">

              <div class="demo-upload-list" v-if="windowAddItem.logo">
                <img :src="windowAddItem.logo" style="max-width: 200px;max-height: 200px">
                <div class="demo-upload-list-cover">
                  <Icon type="ios-trash-outline" @click.native="handleImgRemove('logo')"></Icon>
                </div>
              </div>
              <input v-if="windowAddItem.logo" v-model="windowAddItem.logo" type="hidden" name="image">

              <Upload type="drag"
                      :action="uploadUrl"
                      :headers="uploadHeader"
                      v-if="!windowAddItem.logo"
                      :format="['jpg','jpeg','png','gif']"
                      :max-size="5120"
                      :on-success="handleImgSuccess"
                      :on-format-error="handleImgFormatError"
                      :on-exceeded-size="handleImgMaxSize"
                      style="display: inline-block;width:58px">
                <div style="width: 58px;height:58px;line-height: 58px">
                  <Icon type="md-camera" size="20"></Icon>
                </div>
              </Upload>

            </FormItem>


            <FormItem label="安卓APP下载地址" prop="androidDownUrl" >

                <Input clearable v-model='windowAddItem.androidDownUrl' :placeholder="$t('请输入安卓APP下载地址')" style="width: 500px;"></Input>
                <Upload type="drag"
                        :action="uploadUrl"
                        :headers="uploadHeader"
                        :format="['txt','apk']"
                        :max-size="15120"
                        :on-success="handleApkSuccess"
                        :on-format-error="handleImgFormatError"
                        :on-exceeded-size="handleImgMaxSize"
                        style="margin-left:12px;display: inline-block;width:30px">

                  <div style="width: 30px;height:30px;line-height: 30px">
                    <Icon type="ios-add" size="20"></Icon>
                  </div>
                </Upload>

            </FormItem>

            <FormItem label="IOSAPP下载地址" prop="iosDownUrl" >

              <Input clearable v-model='windowAddItem.iosDownUrl' :placeholder="$t('请输入IOSAPP下载地址')" style="width: 500px;"></Input>
              <Upload type="drag"
                      :action="uploadUrl"
                      :headers="uploadHeader"
                      :format="['txt','mobileconfig']"
                      :max-size="5120"
                      :on-success="handleIOSSuccess"
                      :on-format-error="handleImgFormatError"
                      :on-exceeded-size="handleImgMaxSize"
                      style="margin-left:12px;display: inline-block;width:30px">

                <div style="width: 30px;height:30px;line-height: 30px">
                  <Icon type="ios-add" size="20"></Icon>
                </div>
              </Upload>

            </FormItem>

            <FormItem label='IOSAPP下载地址' prop='iosDownUrl' style="width: 900px">
              <Input clearable v-model='windowAddItem.iosDownUrl' :placeholder="$t('请输入IOSAPP下载地址')"></Input>
            </FormItem>
<!--            <FormItem label='平台默认邀请码' prop='invitation_code' style="width: 300px;">-->
<!--              <Input clearable v-model='windowAddItem.invitation_code' :placeholder="$t('请输入平台默认邀请码')"></Input>-->
<!--            </FormItem>-->
            <!--            <FormItem label='在线客服' prop='kefu_online' style="width: 900px">-->
            <!--              <Input clearable v-model='windowAddItem.kefu_online' :placeholder="$t('请输入在线客服')"></Input>-->
            <!--            </FormItem>-->
            <FormItem label='whatsapp客服' prop='kefu_whatsapp' style="width: 900px">
              <Input clearable v-model='windowAddItem.kefu_whatsapp' :placeholder="$t('请输入whatsapp客服')"></Input>
            </FormItem>
            <FormItem label='一级返佣(%)A' prop='A_rate' style="width: 900px">
              <InputNumber :min='0' clearable v-model='windowAddItem.A_rate' :placeholder="$t('一级返佣')"></InputNumber>
            </FormItem>
            <FormItem label='二级返佣(%)B' prop='B_rate' style="width: 900px">
              <InputNumber :min='0' clearable v-model='windowAddItem.B_rate' :placeholder="$t('二级返佣')"></InputNumber>
            </FormItem>
            <FormItem label='三级返佣(%)C' prop='C_rate' style="width: 900px">
              <InputNumber :min='0' clearable v-model='windowAddItem.C_rate' :placeholder="$t('三级返佣')"></InputNumber>
            </FormItem>

            <FormItem label='一级VIP升级返佣(%)A' prop='vipA_rate'>
              <InputNumber :min='0' v-model='windowAddItem.vipA_rate'
                           :placeholder="$t('一级VIP升级返佣(%)')"></InputNumber>
            </FormItem>

            <FormItem label='二级VIP升级返佣(%)B' prop='vipB_rate'>
              <InputNumber :min='0' v-model='windowAddItem.vipB_rate'
                           :placeholder="$t('二级VIP升级返佣(%)')"></InputNumber>
            </FormItem>

            <FormItem label='三级VIP升级返佣(%)C' prop='vipC_rate'>
              <InputNumber :min='0' v-model='windowAddItem.vipC_rate'
                           :placeholder="$t('三级VIP升级返佣(%)')"></InputNumber>
            </FormItem>

            <FormItem label='新注册免费几天' prop='freeVipDate'>
              <InputNumber :min='1' v-model='windowAddItem.freeVipDate'
                           :placeholder="$t('新注册免费几天')"></InputNumber>
            </FormItem>


            <FormItem label='是否差额升级' prop='isVipUpByDif'>
              <Select clearable v-model='windowAddItem.isVipUpByDif' style='width:200px'>
                <Option :value="0" :key='0'>{{ $t('全额升级') }}</Option>
                <Option :value="1" :key='1'>{{ $t('差额升级') }}</Option>
              </Select>
            </FormItem>


            <FormItem label='余额宝万份收益' prop='yeb_rate' style="width: 900px">
              <Input clearable v-model='windowAddItem.yeb_rate' :placeholder="$t('余额宝万份收益')"></Input>
            </FormItem>

            <!--            <FormItem label='余额宝最低存款天数' prop='yeb_rate' style="width: 900px">-->
            <!--              <Input clearable v-model='windowAddItem.yeb_date' :placeholder="$t('余额宝最低存款天数')"></Input>-->
            <!--            </FormItem>-->

            <FormItem label='幸运订单结算延时(小时)' prop='lucky_hour' style="width: 900px">
              <Input clearable v-model='windowAddItem.lucky_hour' :placeholder="$t('幸运订单结算延时(小时)')"></Input>
            </FormItem>


            <FormItem label='提现手续费（%）' prop='withdraw_rate' style="width: 900px">
              <Input clearable v-model='windowAddItem.withdraw_rate' :placeholder="$t('提现手续费（%）')"></Input>
            </FormItem>

            <FormItem label='提现时间段' prop='withdraw_time' style="width: 900px">
              <TimePicker v-model='windowAddItem.withdraw_time' type="timerange" placement="bottom-end" placeholder="提现时间段" style="width: 168px" />
            </FormItem>
            <FormItem label='周末是否能提现' prop='withdrow_weekend'>
              <Select clearable v-model='windowAddItem.withdrow_weekend' style='width:200px'>
                <Option :value="0" :key='0'>{{ $t('不允许') }}</Option>
                <Option :value="1" :key='1'>{{ $t('允许') }}</Option>
              </Select>
            </FormItem>
            <FormItem label='会员单独入款钱包' prop='isUseUserWallet'>
              <Select clearable v-model='windowAddItem.isUseUserWallet' style='width:200px'>
                <Option :value="0" :key='0'>{{ $t('不使用') }}</Option>
                <Option :value="1" :key='1'>{{ $t('使用') }}</Option>
              </Select>
            </FormItem>
            <FormItem label='是否自动归集' prop='isAutoCollection'>
              <Select clearable v-model='windowAddItem.isAutoCollection' style='width:200px'>
                <Option :value="0" :key='0'>{{ $t('否') }}</Option>
                <Option :value="1" :key='1'>{{ $t('是') }}</Option>
              </Select>
            </FormItem>



            <FormItem label='图片域名' prop='img_url' style="width: 900px">
              <Input clearable v-model='windowAddItem.img_url' :placeholder="$t('图片域名')"></Input>
            </FormItem>


            <!--            <FormItem label='EMAI客服L' prop='kefu_email' style="width: 900px">-->
            <!--              <Input clearable v-model='windowAddItem.kefu_email' :placeholder="$t('请输入EMAI客服L')"></Input>-->
            <!--            </FormItem>-->
            <!--            <FormItem label='telegram客服' prop='kefu_telegram' style="width: 900px">-->
            <!--              <Input clearable v-model='windowAddItem.kefu_telegram' :placeholder="$t('请输入telegram客服')"></Input>-->
            <!--            </FormItem>-->
            <!--            <FormItem label='FACEBOOK客服' prop='kefu_facebook' style="width: 900px">-->
            <!--              <Input clearable v-model='windowAddItem.kefu_facebook' :placeholder="$t('请输入FACEBOOK客服')"></Input>-->
            <!--            </FormItem>-->
            <!--            <FormItem label='line客服' prop='kefu_line' style="width: 900px">-->
            <!--              <Input clearable v-model='windowAddItem.kefu_line' :placeholder="$t('请输入line客服')"></Input>-->
            <!--            </FormItem>-->
            <!--            <FormItem label='zaio客服' prop='kefu_zaio' style="width: 900px">-->
            <!--              <Input clearable v-model='windowAddItem.kefu_zaio' :placeholder="$t('请输入zaio客服')"></Input>-->
            <!--            </FormItem>-->
            <!--            <FormItem label='第三方支付域名' prop='pay_url' style="width: 900px">-->
            <!--              <Input clearable v-model='windowAddItem.pay_url' :placeholder="$t('请输入第三方支付域名')"></Input>-->
            <!--            </FormItem>-->
            <!--            <FormItem label='默认邀请域名' prop='invite_url' style="width: 500px">-->
            <!--              <Input clearable v-model='windowAddItem.invite_url' :placeholder="$t('请输入默认邀请域名')"></Input>-->
            <!--            </FormItem>-->
            <FormItem label='每日提现次数' prop='withdraw_times_day_limit'>
              <InputNumber :min='1' v-model='windowAddItem.withdraw_times_day_limit'
                           :placeholder="$t('请输入每日提现次数')"></InputNumber>
            </FormItem>
            <FormItem label='后台IP白名单' prop='white_ips'>
              <Input type="textarea" :rows="4" v-model='windowAddItem.white_ips'
                     :placeholder="$t('请输入后台IP白名单')"></Input>
            </FormItem>
            <FormItem label='维护公告' prop='weihu_description'>
              <Input type="textarea" :rows="4" clearable v-model='windowAddItem.weihu_description'
                     :placeholder="$t('请输入维护公告')" style="width: 400px"></Input>
            </FormItem>
            <FormItem label='是否开启' prop='status'>
              <Select clearable v-model='windowAddItem.status' style='width:200px'>
                <Option :value="0" :key='0'>{{ $t('未开启') }}</Option>
                <Option :value="1" :key='1'>{{ $t('开启') }}</Option>
                <Option :value="2" :key='2'>{{ $t('平台维护中') }}</Option>
              </Select>
            </FormItem>
            <!--            <FormItem label='72*72小图标' prop='favicon'>-->
            <!--              <Input clearable v-model='windowAddItem.favicon' :placeholder="$t('请输入72*72小图标')"></Input>-->
            <!--            </FormItem>-->
            <!--            <FormItem label='统计代码' prop='tongji_js'>-->
            <!--              <Input clearable v-model='windowAddItem.tongji_js' :placeholder="$t('请输入统计代码')"></Input>-->
            <!--            </FormItem>-->

            <FormItem label="" style="margin-top:20px">
              <Button type="primary" @click="windowAddSubmit" style="margin-right:10px">确定修改/添加</Button>
              <span style="color:red;margin-left:20px;">(修改，添加后，需要“系统配置→清理缓存“后才会生效)</span>
            </FormItem>
          </Form>

        </Card>
      </Col>
    </Row>

    <!-- windowAddEdit -->
    <Modal v-model="windowAdd.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAddItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>

    </Modal>
    <!--    -->
  </div>
</template>
<script>
import internationality from '@/components/internationality'
import {
  getList,
  add,
  del,
  lock,
  getParams,
  changeStatus
} from '@/api/systemManage/siteSetting'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'
import { baseUrl } from '@/libs/api.request'
import { getToken } from '@/libs/util'

export default {
  name: 'interface_list',
  data () {
    return {
      uploadUrlCk: baseUrl + 'Index/uploadCk',
      uploadUrl: baseUrl + 'Index/upload',
      uploadHeader: { 'Api-Auth': getToken() },
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value () {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value () {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value () {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      searchConf: { searchTime: [], }, // 搜索字段
      extraParams: [],
      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAddItem: { //弹窗数据绑定
        id: 0,
        logo: ''
      },
      windowAddValidate: {//窗口校验规则
      },                            //----------------
    }
  },
  components: {
    internationality
  },
  created () {
    let vm = this
    vm.getList()
    vm.hasRule('systemManage/siteSetting/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('systemManage/siteSetting/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('systemManage/siteSetting/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
  },
  mounted () {
    this.getParams()
  },
  methods: {
    preAdd () {
      let vm = this
      vm.windowAdd.show = true
    },
    getParams () {
      // getParams().then(response => {
      //     this.extraParams = response.data.data
      // })
    },
    changePage (page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize (size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search () {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList () {
      let vm = this
      vm.listLoading = true
      getList({
        page: vm.tableShow.currentPage,
        size: vm.tableShow.pageSize,
        search: vm.searchConf
      }).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
        vm.windowAddItem = response.data.data.list[0]
      })
    },

    timeChange (datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({ column, key, order }) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowAddCancel (data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    }, windowAddSubmit () {
      let vm = this
      vm.windowAdd.loading = true
      add(vm.windowAddItem).then(response => {
        vm.$Message.success(response.data.msg)
        vm.getList()
        vm.windowAddCancel()
      }).catch(() => {
        vm.windowAdd.loading = false
      })

    }, handleImgFormatError (file) {
      this.$Notice.warning({
        title: '文件类型不合法',
        desc: file.name + '的文件类型不正确，请上传jpg或者png图片。'
      })
    },
    handleImgRemove (key) {
      this.windowAddItem[key] = ''
    },
    handleImgSuccess (response) {
      if (response.code === 1) {
        this.$Message.success(response.msg)
        this.windowAddItem.logo = response.data.fileUrl
        //由于字段是动态的，所以查找一下 图片字段，再显示
        // for (let key in this.windowAdd.windowsParams2) {
        //   if (this.windowAdd.windowsParams2[key]['type'] == 'image') {
        //     this.windowAddItem[key] = response.data.fileUrl
        //   }
        // }
      } else {
        this.$Message.error(response.msg)
      }
    },
    handleApkSuccess (response) {
      if (response.code === 1) {
        this.$Message.success(response.msg)
        this.windowAddItem.androidDownUrl = response.data.fileUrl
        //由于字段是动态的，所以查找一下 图片字段，再显示
        // for (let key in this.windowAdd.windowsParams2) {
        //   if (this.windowAdd.windowsParams2[key]['type'] == 'image') {
        //     this.windowAddItem[key] = response.data.fileUrl
        //   }
        // }
      } else {
        this.$Message.error(response.msg)
      }
    },
    handleIOSSuccess (response) {
      if (response.code === 1) {
        this.$Message.success(response.msg)
        this.windowAddItem.iosDownUrl = response.data.fileUrl
        //由于字段是动态的，所以查找一下 图片字段，再显示
        // for (let key in this.windowAdd.windowsParams2) {
        //   if (this.windowAdd.windowsParams2[key]['type'] == 'image') {
        //     this.windowAddItem[key] = response.data.fileUrl
        //   }
        // }
      } else {
        this.$Message.error(response.msg)
      }
    },


    handleImgMaxSize (file) {
      this.$Notice.warning({
        title: '文件大小不合法',
        desc: file.name + '太大啦请上传小于5M的文件。'
      })
    },
  }
}
</script>
